import * as types from './actionTypes'

const initialState = {
    isLoading: false,
    data: [],
    logo: null,
    current: '',
    contacts: [],
    publicAccess: null,
    users: []
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.APPLICATIONS_GET: {
        	const current = action.apps.find(item => item.isCurrent)

            return {
                ...state,
                data: [...action.apps],
                current: current.id,
                logo: action.logo
            }
		}

        case types.CHANGE_APPLICATION_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.CHANGE_APPLICATION_SUCCESS: {
            const current = action.apps.find(item => item.isCurrent)
			
            return {
                ...state,
                data: [...action.apps],
                current: current.id,
                logo: action.logo,
				isLoading: false
            }
		}

        case types.CHANGE_APPLICATION_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SET_APPLICATION_LOGO:
            return {
                ...state,
                isLoading: true
            }

        case types.SET_APPLICATION_LOGO_SUCCESS:
            return {
                ...state,
                logo: action.logo,
                isLoading: false
            }

        case types.SET_APPLICATION_LOGO_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SET_APPLICATION_NAME:
            return {
                ...state,
                isLoading: true
            }

        case types.SET_APPLICATION_NAME_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.SET_APPLICATION_NAME_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.CALL_USERS_SUCCESS:
            return {
                ...state,
                contacts: action.contacts
            }

        case types.CALL_USERS_FAILED:
            return {
                ...state
            }

        case types.PUBLIC_ACCESS_SUCCESS:
            return {
                ...state,
                publicAccess: action.data
            }

        case types.PUBLIC_ACCESS_FAILED:
            return {
                ...state
            }

        case types.SENDER_CREATE:
            return {
                ...state,
                isLoading: true
            }

        case types.SENDER_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.SENDER_CREATE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SENDER_DELETE:
            return {
                ...state,
                isLoading: true
            }

        case types.SENDER_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.SENDER_DELETE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.SENDER_VERIFY:
            return {
                ...state,
                isLoading: true
            }

        case types.SENDER_VERIFY_SUCCESS:
            return {
                ...state,
                isLoading: false
            }

        case types.SENDER_VERIFY_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.USERS_FETCH:
            return {
                ...state,
                isLoading: true
            }

        case types.USERS_FETCH_SUCCESS:
            return {
                ...state,
                users: action.users,
                isLoading: false
            }

        case types.USERS_FETCH_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.USER_UPDATE:
            return {
                ...state,
                isLoading: true
            }

        case types.USER_UPDATE_SUCCESS: {
            const users = [...state.users]
            const index = state.users.findIndex(item => item.id === action.user.id)
            index === -1 ? users.splice(users.length, 0, action.user) : users.splice(index, 1, action.user)

            return {
                ...state,
                users,
                isLoading: false
            }
        }

        case types.USER_UPDATE_FAILED:
            return {
                ...state,
                isLoading: false
            }

        case types.USER_DELETE:
            return {
                ...state,
                isLoading: true
            }

        case types.USER_DELETE_SUCCESS: {
            const users = [...state.users]
            const index = state.users.findIndex(item => item.name === action.user)
            users.splice(index, 1)

            return {
                ...state,
                users,
                isLoading: false
            }
        }

        case types.USER_DELETE_FAILED:
            return {
                ...state,
                isLoading: false
            }

		case types.SET_OWNER:
            return {
                ...state,
                isLoading: true
            }

        case types.SET_OWNER_SUCCESS: {
            return {
                ...state,
                users: [...action.users],
                isLoading: false
            }
        }

        case types.SET_OWNER_FAILED:
            return {
                ...state,
                isLoading: false
            }

        default:
            return state
    }
}
